import { CONSTANT_TEXTS } from '@gp/constants/const';

import type { IDynamicSelectMultipleFilterControl } from '@gp/components/DynamicFilter/components/FilterControl/types';

export const GROUP_KEY = 'separated';

export const GROUPS = { [GROUP_KEY]: CONSTANT_TEXTS.SELECT_SEPARATED_GROUP_NAME };

export const ALL_OPTION = {
  value: 'all',
  text: 'All',
};

export const COMMON_SELECT_MULTIPLE_CONTROL_CFG: Partial<IDynamicSelectMultipleFilterControl> = {
  staging: false,
  groups: GROUPS,
  allOption: ALL_OPTION,
  clearable: false,
  searchable: true,
  sortable: true,
  matchButtonWidth: true,
  searchPlaceholder: 'Search',
};

// 级联信息List
export const CASCADE_INFO_LIST = [
  {
    level: 1,
    key: 'pteam',
    nameKey: 'pteam',
    title: 'P-team',
    titleKey: 'Pteam',
    isEndPanel: false,
  },
  {
    level: 2,
    key: 'bussiness_owner',
    nameKey: 'bussiness_owner',
    title: 'BO',
    titleKey: 'BO',
    isEndPanel: false,
  },
  {
    level: 3,
    key: 'studio_id',
    nameKey: 'studio',
    title: 'Studio',
    titleLablKey: 'Studio',
    isEndPanel: false,
  },
  {
    level: 4,
    key: 'project_id',
    nameKey: 'project',
    title: 'Project',
    titleKey: 'Project',
    isEndPanel: true,
  },
];

// Stage信息List,大小写互通
export const STAGE_VALUE_TEXT = {
  live: 'Live',
  development: 'Development',
  legacy: 'Legacy',
  'pre-planned': 'Pre-Planned',
  planned: 'Planned',
  canceled: 'Canceled',
  'no maintenance': 'No Maintenance',
  Live: 'Live',
  Development: 'Development',
  Legacy: 'Legacy',
  'Pre-planned': 'Pre-Planned',
  Planned: 'Planned',
  Canceled: 'Canceled',
  'No maintenance': 'No Maintenance',
} as any;
